import { render } from "./MerchantTotalSales.vue?vue&type=template&id=6beef03a&scoped=true"
import script from "./MerchantTotalSales.vue?vue&type=script&lang=js"
export * from "./MerchantTotalSales.vue?vue&type=script&lang=js"

import "./MerchantTotalSales.vue?vue&type=style&index=0&id=6beef03a&scoped=true&lang=css"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6beef03a"]])

export default __exports__